
  import clearableTabIndex from '@/mixins/clearableTabIndex';

  export default {
    name: 'SectionRatingForm',
    mixins: [clearableTabIndex],
    data() {
      return {
        comment: '',
      };
    },
  };
